import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Footer.css';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="app-container">
        <div className="site-footer__top">

          <div className="site-footer__brand">
            <Link
              to="/"
              className="site-footer__logo"
              aria-label="АПП — на главную"
            >
              <img
                src={`${process.env.PUBLIC_URL}/images/footer_logo.png`}
                alt="Ассоциация Практикующих Психологов"
              />
            </Link>

            <h2 className="site-footer__brand-title">
              Ассоциация Практикующих Психологов
            </h2>

            <div className="site-footer__social">
              <a
                href="https://vk.ru/spp_psy_tomsk"
                target="_blank"
                rel="noopener noreferrer"
              >
                ВКонтакте
              </a>

              <a
                href="https://t.me/spp_psy_tomsk"
                target="_blank"
                rel="noopener noreferrer"
              >
                Telegram
              </a>
            </div>
          </div>

          <div className="site-footer__column">
            <h3>Ассоциация</h3>
            <Link to="/about">Что такое АПП?</Link>
            <Link to="/about#history">История</Link>
            <Link to="/about#members">Члены АПП</Link>
            <Link to="/about#ethics">Этический кодекс</Link>
            <Link to="/about#friends">Наши друзья</Link>
            <Link to="/join_association">Вступить в АПП</Link>
          </div>


           <div className="site-footer__column">
            <h3>Коллегам</h3>
    
            <Link to="/resources">Возможности для коллег</Link>
            <Link to="/join_association">Вступление в АПП</Link>
            <Link to="/benefits/education">Обучение</Link>
         
          </div>

          <div className="site-footer__column">
            <h3>Клиентам</h3>
            <Link to="/find-psychologist">Индивидуальная терапия</Link>
            <Link to="/benefits/grupp_psy">Психотерапевтические группы</Link>

          </div>

         

          <div className="site-footer__column site-footer__contacts">
            <h3>Контакты</h3>

            <p>г. Томск</p>
            <p>пр. Ленина, 55</p>
            <p>4 этаж, кабинет 412</p>

            <Link to="/archive">
              Архив мероприятий
            </Link>
          </div>

        </div>

        <div className="site-footer__bottom">
          <p>
            © {currentYear} Ассоциация Практикующих Психологов
          </p>

          <p>
            Разработано JeckS
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;